import _ from "lodash";
import { formatSpeedAtImpact, formatSpeedLimit } from "./unit";

const getSpeedSummaryText = (report) => {
  if (_.get(report, 'crashEvent.speedBeforeImpact') < 5) {
    return `The vehicle had stopped at least ${new Date(
      report.crashEvent.timestamp -
      report.crashEvent.speedBeforeImpactTimestamp
    ).getMinutes()} seconds/minutes before the crash impact was detected.`;
  } else if (_.get(report, 'crashEvent.speedAtImpact') > 5) {
    return `The vehicle was travelling at a speed of ${formatSpeedAtImpact(
      _.get(report, 'crashEvent.speedAtImpact')
    )} when the crash impact was detected.
`;
  }
  return false;
};

const getRoadTypeSummaryText = (report) => {
  if ((_.get(report, 'crashEvent.roadType', null)) && (_.get(report, 'crashEvent.speedLimit', null))) {
    return `It was travelling on a ${(_.get(report, 'crashEvent.roadType', null))
      } with speed limit of ${formatSpeedLimit(
        (_.get(report, 'crashEvent.speedLimit', null))
      )} during impact.`;
  }
  return false;
};

const getTrafficDataSummaryText = (report) => {
  if (_.get(report, 'trafficIncidentData', []).length > 0 &&
    report.trafficIncidentData[0].trafficIncidents != null &&
    report.trafficIncidentData[0].trafficIncidents[0].location < 500
  ) {
    return `There was a traffic incident (${report.trafficIncidentData.trafficIncidents.incidentType}) close to the crash impact location.`;
  } else if (
    _.get(report, 'trafficFlow', []).length > 0 &&
    report.trafficFlow[0].currentSpeed > report.crashEvent.speedAtImpact
  ) {
    return `The vehicle was driving at considerably lower speed than the typical traffic flow when the crash happened.
    `;
  } else if (
    _.get(report, 'trafficFlow', []).length > 0 &&
    report.trafficFlow[0].currentSpeed < report.crashEvent.speedAtImpact
  ) {
    return 'The vehicle was driving at considerably higher speed than the typical traffic flow when the crash happened.';
  }
  return false;
};

const getDrivingEventsSummaryText = (report) => {
  if (_.get(report, 'crashEvent.speeding', false) &&
    report.crashEvent.phoneHandling === false &&
    report.crashEvent.harshEvents === false
  ) {
    return 'There were no harsh braking, acceleration or phone handling or speeding events reported during the trip. The driver seems to be following the rules during the trip.';
  } else if (
    _.get(report, 'crashEvent.speedingBeforeImpact', null) === false === false &&
   _.get(report,'crashEvent.phoneHandlingBeforeImpact', null) === false &&
    report.crashEvent.harshEventsBeforeImpact == false
  ) {
    return 'There were no harsh braking, acceleration, phone handling or speeding events 0-5 minutes before the crash impact was detected.';
  }
  return false;
};

const getWeatherSummaryText = (report) => {
  if (_.get(report, 'weatherData', []).length > 0) {
    if (
      report.weatherData[0].precipitation === 'NO' &&
      report.weatherData[0].windText === 'LOW' &&
      report.weatherData[0].visibility === 'HIGH' &&
      report.weatherData[0].glareText === 'UNLIKELY'
    ) {
      return 'No unfavourable weather conditions were reported at the time of impact.';
    }
    return `There was ${report.weatherData[0].precipitationText} snow/rain at the time of impact.
    The visibility was ${report.weatherData[0].visibilityText} at the time of impact.
    The solar glare was ${report.weatherData[0].glareText} at the time of impact.`;
  }
  return false;
};

export const getSummaryText = (report) => {
  return {
    speed: getSpeedSummaryText(report),
    road: getRoadTypeSummaryText(report),
    traffic: getTrafficDataSummaryText(report),
    drivingEvents: getDrivingEventsSummaryText(report),
    weather: getWeatherSummaryText(report),
  };
};
